import { Stack, ToggleButton, ToggleButtonGroup, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

interface ValuationOwnerToggleProps {
  showOnlyMine: boolean;
  setShowOnlyMine: (value: boolean) => void;
  totalRecords?: number | null;
}

const styles = {
  toggleButton: {
    border: "1px solid rgba(0, 0, 0, 0.54) !important",
    "&:hover": {
      bgcolor: "inherit",
    },
    "&.Mui-selected:hover": {
      bgcolor: "primary.main",
    },
    ".MuiTouchRipple-root": { display: "none" },
  },
  leftButton: {
    borderTopLeftRadius: "4px ",
    borderBottomLeftRadius: "4px",
    borderTopRightRadius: "0 !important",
    borderBottomRightRadius: "0 !important",
  },
  rightButton: {
    borderTopLeftRadius: "0 !important",
    borderBottomLeftRadius: "0 !important",
    borderTopRightRadius: "4px",
    borderBottomRightRadius: "4px",
    borderLeft: "none !important",
  },
};

export const ValuationOwnerToggle: React.FC<ValuationOwnerToggleProps> = ({ showOnlyMine, setShowOnlyMine }) => {
  const { t } = useTranslation("ValuationListPage");

  return (
    <Stack spacing={2} pb={2}>
      <Typography variant="subText">{t("advertisements")}</Typography>
      <ToggleButtonGroup
        color="primary"
        value={showOnlyMine}
        exclusive
        onChange={(_e, newValue) => {
          if (newValue !== null) setShowOnlyMine(!showOnlyMine);
        }}
        sx={{ height: "36px", mb: 2 }}
      >
        <ToggleButton value={true} sx={{ ...styles.toggleButton, ...styles.leftButton }}>
          {t("myValuations")}
        </ToggleButton>
        <ToggleButton value={false} sx={{ ...styles.toggleButton, ...styles.rightButton }}>
          {t("allValuations")}
        </ToggleButton>
      </ToggleButtonGroup>
    </Stack>
  );
};
